'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';

import styles from './FormSection.module.scss';

type GroupProps = BaseComponentProps & {
  title: string;
  children?: ReactNode;
};

function FormSection({
  style,
  className,
  title,
  children,
  testId = 'ui-form-section',
}: GroupProps) {
  return (
    <div
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      <h2>{title}</h2>
      {children}
    </div>
  );
}

export { FormSection };
